import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';

export type StickyActionBarProps = {
  leftContainer?: React.ReactNode;
};

export const StickyActionBar: React.FC<StickyActionBarProps> = ({ leftContainer, children }) => {
  const { classes, cx } = useStyles();

  return (
    <Box className={cx(classes.container, leftContainer ? classes.splitContent : classes.singleContent)}>
      {leftContainer}
      <Box className={classes.content}>
        {children}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({ name: 'StickyActionBar' })((theme) => ({
  container: {
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    boxShadow: `inset 0 1px 0 ${grey[300]}`,
    zIndex: theme.zIndex.appBar,
    position: 'sticky',
    bottom: 0,
    display: 'flex',
  },
  content: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  singleContent: {
    justifyContent: 'flex-end',
  },
  splitContent: {
    justifyContent: 'space-between'
  },
}));
